import ProtectedRoute from "@/components/helpers/ProtectedRoute";
import LiveWirePage from "@/pages/reports/LiveWirePage";

const ReportRoutes = [
  {
    path: "reports/livewire",
    element: (
      <ProtectedRoute>
        <LiveWirePage />
      </ProtectedRoute>
    ),
  },
];

export default ReportRoutes;
